import { Component, Injector, OnInit } from '@angular/core';
import { ModalComponent } from '../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-modal-generic',
  templateUrl: './modal-generic.component.html',
  styleUrls: ['./modal-generic.component.scss'],
  standalone: false,
})
export class ModalGenericComponent implements OnInit {
  private modalComponent: ModalComponent;

  public message: string;
  public euribor: string;
  public insurance: string;
  public boeEuribor: string;
  public txtButton: string;
  public txtButtonCancel: string;
  public showIcon = false;

  constructor(private _inj: Injector) {
    this.modalComponent = this._inj.get(ModalComponent);
    this.message =
      !!this.modalComponent.data && !!this.modalComponent.data.message
        ? this.modalComponent.data.message
        : '';
    this.euribor =
      !!this.modalComponent.data && !!this.modalComponent.data.euribor
        ? this.modalComponent.data.euribor
        : '';
    this.insurance =
      !!this.modalComponent.data && !!this.modalComponent.data.insurance
        ? this.modalComponent.data.insurance
        : '';
    this.boeEuribor =
      !!this.modalComponent.data && !!this.modalComponent.data.boeEuribor
        ? this.modalComponent.data.boeEuribor
        : '';
    this.txtButton =
      !!this.modalComponent.data && !!this.modalComponent.data.txtButton
        ? this.modalComponent.data.txtButton
        : 'btn_aceptar';
    this.txtButtonCancel =
      !!this.modalComponent.data && !!this.modalComponent.data.txtButtonCancel
        ? this.modalComponent.data.txtButtonCancel
        : '';
    this.showIcon =
      !!this.modalComponent.data && !!this.modalComponent.data.showIcon
        ? this.modalComponent.data.showIcon
        : false;
  }

  ngOnInit() {}

  accept() {
    this.modalComponent.accept();
  }

  cancel() {
    this.modalComponent.reject();
  }
}
